import { ScenarioChartContainer } from '@/styles/scenario';
import {
	defaultColorChartAtZero,
	defaultFontChartAtZero,
	drawLineAtZeroPlugin,
} from '@/utils/utils';
import React from 'react';
import { Chart } from 'react-chartjs-2';

interface CapacityChartProps {
	scenario: TCapacityChartData[];
	title: string;
}

const options = {
	responsive: true,
	maintainAspectRatio: false,
};

// export const generateColorPalette = (): string[] => {
// 	const palette: string[] = [];

// 	// Générer une couleur RGB aléatoire
// 	const generateRandomColor = (): string => {
// 		const r = Math.floor(Math.random() * 256);
// 		const g = Math.floor(Math.random() * 256);
// 		const b = Math.floor(Math.random() * 256);
// 		return `rgb(${r}, ${g}, ${b})`;
// 	};

// 	// Calculer la distance euclidienne entre deux couleurs RGB
// 	const calculateColorDistance = (color1: string, color2: string): number => {
// 		const [r1, g1, b1] = color1.match(/\d+/g)!.map(Number);
// 		const [r2, g2, b2] = color2.match(/\d+/g)!.map(Number);
// 		const dr = r2 - r1;
// 		const dg = g2 - g1;
// 		const db = b2 - b1;
// 		return Math.sqrt(dr * dr + dg * dg + db * db);
// 	};

// 	// Vérifier si une couleur est suffisamment éloignée des autres couleurs de la palette
// 	const isColorDistinct = (color: string, colors: string[]): boolean => {
// 		for (const existingColor of colors) {
// 			if (calculateColorDistance(color, existingColor) < 100) {
// 				return false;
// 			}
// 		}
// 		return true;
// 	};

// 	while (palette.length < 20) {
// 		const newColor = generateRandomColor();
// 		if (isColorDistinct(newColor, palette)) {
// 			palette.push(newColor);
// 		}
// 	}

// 	return palette;
// };

export const generateColorPalette = (): string[] => [
	'#E91E63',
	'#2196F3',
	'#3F51B5',
	'#FFEB3B',
	'#00BCD4',
	'#9C27B0',
	'#FF9800',
	'#009688',
	'#4CAF50',
	'#CDDC39',
	'#FFC107',
	'#03A9F4',
	'#FF5722',
	'#795548',
	'#673AB7',
	'#9E9E9E',
	'#8BC34A',
	'#607D8B',
	'#F44336',
];

const palette = generateColorPalette();

const CapacityChart: React.FC<CapacityChartProps> = ({ scenario, title }) => {
	const convertData = (input: TCapacityValues) => {
		return Object.entries(input)
			.map(([key, value]) => ({
				[key]: value.value,
			}))
			.reduce((acc, curr) => ({ ...acc, ...curr }), {});
	};

	return (
		<ScenarioChartContainer>
			{scenario.length > 0 && (
				<Chart
					type='bar'
					data={{
						datasets: scenario.map((item) => ({
							type: 'bar',
							label: item.name,
							data: convertData(item.values),
							backgroundColor: palette[scenario.indexOf(item)],
							yAxisID: item.name?.includes('Fermentation') ? 'y1' : 'y',
						})),
					}}
					plugins={[drawLineAtZeroPlugin]}
					options={{
						...options,
						plugins: {
							title: {
								display: true,
								text: title,
							},
						},
						scales: {
							y: {
								beginAtZero: true,
								type: 'linear',
								display: true,
								title: {
									display: true,
									text: 'Tonnes as is',
								},
								position: 'left',
								ticks: {
									font: defaultFontChartAtZero,
									color: defaultColorChartAtZero,
								},
							},
							y1: {
								beginAtZero: true,
								type: 'linear',
								display: true,
								position: 'right',
								title: {
									display: true,
									text: 'Tonnes L32',
								},
								grid: {
									drawOnChartArea: false,
								},
								ticks: {
									font: defaultFontChartAtZero,
									color: defaultColorChartAtZero,
								},
							},
						},
					}}
				/>
			)}
		</ScenarioChartContainer>
	);
};

export default CapacityChart;
